import { createSelector, createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/store/store";

import { IOnboardingSteps } from "@/models/onboarding";

interface IOnboarding {
  steps: IOnboardingSteps;
}
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState: {
    steps: IOnboardingSteps.LANGUAGE,
  },
  reducers: {
    setSteps: (state: IOnboarding, action) => {
      state.steps = action.payload;
    },
  },
});

const selectOnboarding = (state: RootState) => state.onboarding;

export const onboarding = createSelector(
  [selectOnboarding],
  (selectOnboarding) => {
    return {
      steps: selectOnboarding.steps,
    };
  }
);

export const { setSteps } = onboardingSlice.actions;
export default onboardingSlice.reducer;
